function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  max-width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Semantics, Tokens } from '../themes/default/spacing';
import { css } from 'styled-components'; // prettier-ignore

export var BASE_STYLES = css(_templateObject());

var spacingValues = _objectSpread({}, Tokens, Semantics);

export var BASE_SPACING = spacingValues.Small;
export var Justification = {
  Center: 'center',
  FlexStart: 'flex-start',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around'
};
export var Alignment = {
  Center: 'center',
  FlexStart: 'flex-start',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
  Stretch: 'stretch'
};
export default spacingValues;